<template>
  <CommonSwiper
    :autoplay="false"
    :options="swiperOptions"
    :slides="banners"
    @ready="swiper = $event"
    @SlideClick="checkClick"
    @visible="
      visible = $event
      visible && reportShow()
    "
  >
    <div class="swiper-wrapper">
      <div
        v-for="(item, i) in banners"
        :key="i"
        class="swiper-slide"
        :style="`background:url(${item.img_url}) top center no-repeat`"
      >
        <!-- <img :src="item.img_url" /> -->
        <div v-if="item.extra_json" class="wp-swiper">
          <!-- banner图链接 -->
          <a href="javascript:;" class="link-box"></a>
          <!-- 文本在左class="b-info left"，文本在右class="b-info right" -->
          <div class="b-info right">
            <p class="t1">{{ item.extraJson.title }}</p>
            <p class="t2">{{ item.extraJson.sub_title }}</p>
            <p class="t3">{{ item.extraJson.description }}</p>
            <a href="javascript:;" class="b-btn">
              {{ item.extraJson.btn_content }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </CommonSwiper>
</template>

<script>
export default {
  data() {
    return {
      swiperOptions: {
        // effect: 'fade',
        onlyExternal: false,
        autoplay: 5000,
        loop: true
      },
      banners: [],
      swiper: null,
      visible: false
    }
  },
  created() {
    if (process.client) {
      this.$request('homeSlice').then((data = []) => {
        this.banners = data.map((e) => ({
          ...e,
          extraJson: this.getExtra(e.extra_json)
        }))
        this.visible && this.reportShow()
      })
    }
  },
  methods: {
    checkClick(ev) {
      if (ev.target.className === 'b-btn') {
        this.slideClick()
        this.reportClick()
      }
    },
    reportShow() {
      if (!this.banners.length) return
      this.$xlaPush('home_page_banner_content_show', this.getExtData())
    },
    reportClick() {
      this.$xlaPush('home_page_banner_content_click', this.getExtData())
    },
    getExtData(e) {
      const index = this.swiper.activeIndex
      const { collection_type, game_id, title, extraJson = {} } =
        this.banners[index] || {}
      const isGame = Global.CONS.CollectionType.game === collection_type
      return {
        area: 'top',
        rn: index,
        game_id: isGame ? game_id : 'other',
        game_name: isGame ? title : 'other',
        url: extraJson.btn_url
      }
    },
    slideClick() {
      const index = this.swiper.getIndex()
      const cur = this.banners[index] || {}
      this.$util.gameStat(
        cur.game_id,
        cur.new_server_id,
        `GWSY/JDT${index + 1}`,
        `官网首页/焦点图${index + 1}`
      )
    },
    getExtra(extra_json) {
      try {
        return JSON.parse(extra_json)
      } catch (e) {
        return {}
      }
    }
  }
}
</script>
